import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Drug} from "../../model/drug";

@Component({
  selector: 'gen-drug-editor',
  templateUrl: './drug-editor.component.html',
  styleUrls: ['./drug-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrugEditorComponent {

  @Input() drug: Drug;
  @Output() deleteMe = new EventEmitter<Drug>();

  constructor() {
  }

  ngOnInit() {
  }

  onClick(): void {
    this.deleteMe.emit(this.drug);
  }
}
